import React from "react";
import axios from "axios";
import Grid from '@mui/material/Grid';
import ActionAlert from '../../../../../../components/Alert/ActionAlert.jsx';
import * as c from '../../../../../../constants.jsx';
import TextCardBold from "../../../../../../components/TextComps/TextCardBold.jsx";
import TextCard from "../../../../../../components/TextComps/TextCard.jsx";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { useTheme } from "@mui/material";
import Divider from '@mui/material/Divider';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';


export default function GetGenus() {

  const theme = useTheme();

const url_genus = `${c.API_URL}/api/mentero`

const [genusInfo, setGenusInfo] = React.useState(null);
const [error, setError] = React.useState(null);

React.useEffect(() => {retrievePanel();}, []);

const retrievePanel = () => {
  axios
    .get(url_genus)
    .then((res) => {
      setGenusInfo(res.data.slice(0,10));

    })
    .catch(function (error) {
      if (error.response) {
        // Request made and server responded
        setError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        setError("The request was made but no response was received.");
      } else {
        // Something happened in setting up the request that triggered an Error
        setError("Error: " + error.message);
      }
    });
};

return(
<>

 {genusInfo ? 

     theme.palette.mode === "light" ? (
    
      <Accordion elevation={3} sx={{width: '100%', bgcolor: 'grey.C200', }}>     
    
      <AccordionSummary aria-controls="panel1-content" id="panel1-header"
         expandIcon={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip title="This lists the ten most common bacterial genera. From the HMP (Human Microbiome Project) the expected top genera are Streptococcus, Veillonella, Prevotella, Rothia, Neisseria. In biology, the classification hierarchy goes from: Domain → Kingdom → Phylum → Class → Order → Family → Genus → Species → Strain." >
                   <span> <IconButton sx={{ pointerEvents: 'none' }} size="small"> <InfoOutlineIcon fontSize="small" /> </IconButton> </span>
                </Tooltip>
                <ExpandMoreIcon />
              </div>
            }
        > 
                <TextCardBold textcard="TOP 10 Genera → Entero Type" />    
        </AccordionSummary> 
     
        <AccordionDetails sx={{ }}>
    
          <Grid container sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',  borderRadius: '14px', }}> 
              
              <Grid size={7} sx={{pl:1, mb:1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="GENUS" /> </Grid>
              <Grid size={5} sx={{mb:1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="REL. ABUNDANCE" /> </Grid>
              <Grid size={12}> <Divider role="presentation" sx={{ mb:1, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>

            {genusInfo.map((i, index) =>  
                <>
              <Grid size={6} sx={{pl:1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCard textcard={i.genus} /> </Grid>
              <Grid size={5} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>  <TextCard textcard={Math.round(i.relative_abundance * 10) / 10} /> </Grid>
        </>)}
    
        </Grid>   

    </AccordionDetails>

</Accordion>

     ) : (

      <Accordion elevation={3} sx={{width: '100%', bgcolor: 'greydark.C800', }}>     
    
      <AccordionSummary aria-controls="panel1-content" id="panel1-header"
         expandIcon={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip title="This lists the ten most common bacterial genera, which define your gut's main bacterial community and help determine your enterotype. Dominance depends heavily on diet, antibiotics, host genetics, and health status. Western diets (high in fat, protein, and low fiber) favor Bacteroides. Faecalibacterium and Roseburia are commonly cited as health-promoting. In biology, the classification hierarchy goes from: Domain → Kingdom → Phylum → Class → Order → Family → Genus → Species → Strain." >
                   <span> <IconButton sx={{ pointerEvents: 'none' }} size="small"> <InfoOutlineIcon fontSize="small" /> </IconButton> </span>
                </Tooltip>
                <ExpandMoreIcon />
              </div>
            }
        > 
                <TextCardBold textcard="TOP 10 Genera → Entero Type" />    
        </AccordionSummary> 
     
        <AccordionDetails sx={{ }}>
    
          <Grid container sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',  borderRadius: '14px', }}> 
              
              <Grid size={7} sx={{pl:1, mb:1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="GENUS" /> </Grid>
              <Grid size={5} sx={{mb:1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard="REL. ABUNDANCE" /> </Grid>
              <Grid size={12}> <Divider role="presentation" sx={{ mb:1, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>

            {genusInfo.map((i, index) =>  
                <>
              <Grid size={6} sx={{pl:1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCard textcard={i.genus} /> </Grid>
              <Grid size={5} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>  <TextCard textcard={Math.round(i.relative_abundance * 10) / 10} /> </Grid>
        </>)}
    
        </Grid>   

    </AccordionDetails>

</Accordion>





     )
    

 : 

    <Grid mt={2} mb={2} justifyContent="center" container spacing={2}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
        <ActionAlert
            severity="warning"
            message={"Currently no information available"}
        />
        </Grid>
    </Grid>

}

{error && (
          <Grid mt={2} mb={1} justifyContent="center" container spacing={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <ActionAlert severity="error" message={error.message} />
            </Grid>
          </Grid>
)}

</> 
)
}

